import { ReactNode } from 'react';
import { KText } from '@/ui-library/components';
import { HeaderCell } from '@/components/ats/Table/tableCells/HeaderCell';
import { Box, Flex, Tooltip } from '@chakra-ui/react';

interface CellProps {
  title: string;
  accessor: string;
  sort?: boolean;
  width: number | string;
  border?: boolean;
  render?: (value: any, row: any) => ReactNode;
  renderFooter?: (value: any) => ReactNode;
  hidePercent?: boolean;
  metricDefinition?: string;
  basedOn?: string;
  category?: string;
  enabletooltip?: boolean;
  id?: string;
  columnConfig?: boolean | string;
}

export const renderCell = ({
  title,
  accessor,
  sort = false,
  render,
  width,
  renderFooter,
  hidePercent = false,
  metricDefinition,
  basedOn,
  category,
  enabletooltip,
  columnConfig,
}: CellProps) => {
  const renderPopoverContent = () => {
    const metricInfo = [
      { key: 'Metric definition', value: metricDefinition },
      { key: 'Based on', value: basedOn },
    ].filter((item) => item.value);

    return (
      <Flex flexDir="column" gap="12px" p="8px 12px">
        {metricInfo.map((item, index) => (
          <Flex flexDir="column" gap="6px" key={index}>
            <KText color="secondary-900" size="sm-medium" textTransform="none">
              {item.key}
            </KText>
            <KText textTransform="none">{item.value}</KText>
          </Flex>
        ))}
      </Flex>
    );
  };

  return {
    Header: () => {
      return enabletooltip ? (
        <Tooltip
          bg="white"
          borderColor="border-color"
          borderWidth="1px"
          borderRadius="12px"
          placement="top"
          hasArrow
          w="300px"
          label={renderPopoverContent()}
        >
          <Box>
            <HeaderCell title={title} variant="" textTransform="none" />
          </Box>
        </Tooltip>
      ) : (
        <HeaderCell title={title} variant="" textTransform="none" />
      );
    },
    accessor,
    sort,
    width,
    Cell: ({ cell, row }) => {
      return (
        <KText
          fontWeight={row.canExpand && row.depth === 0 ? '650' : '550'}
          size="sm"
        >
          {render ? render(cell?.value, row?.original) : cell?.value}
        </KText>
      );
    },
    Footer: (info) => {
      const footer = renderFooter?.(info);
      if (typeof footer === 'number') {
        return (
          <KText size="sm-semi-bold">
            {renderFooter && footer
              ? `${footer} ${!hidePercent ? '(100%)' : ''}`
              : '-'}
          </KText>
        );
      }
      return <>{footer}</>;
    },
    title,
    columnConfig,
  };
};
